import { Flex } from "@gravity-ui/uikit";
import { ImageDto } from "definitions/product-storage";
import { useMemo } from "react";
import { ImageSlider } from "src/components";
import { buildImageUrl } from "src/util";

export const ProductImage = ({
  images,
  size,
}: {
  images: ImageDto[];
  size: number;
}) => {
  const imageSliders = useMemo(
    () =>
      images?.map((image) =>
        buildImageUrl(image.image, {
          width: 1200,
          height: 1200,
          format: "webp",
        }),
      ) ?? [],
    [images],
  );

  return (
    <Flex justifyContent={"center"}>
      <ImageSlider images={imageSliders} size={size} />
    </Flex>
  );
};
